import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { logOut } from '../slice/authSlice'
import { toast } from 'react-toastify'

const baseQuery = fetchBaseQuery({
  baseUrl:"https://hospital.nemaai.com/api",
  prepareHeaders: (headers, { getState }) => {
    const token = getState()?.auth?.userToken
    if (token) {
      headers.set('Authorization', `Bearer ${token}`)
    }
    return headers
  },
})

async function baseQueryWithAuth(args, api, extraOptions) {
  const result = await baseQuery(args, api, extraOptions)

  if (result.error) {
    const { status, data, error } = result.error

    if (status === 401) {
      toast.error('Unauthorized, please log in again.')
      api.dispatch(logOut())
    } else if (status === 403) {
      // Forbidden error, show a permission error message
      toast.error('You do not have permission to perform this action.')
    } else {
      // Default error handling
      const errorMessage = data?.error || error || 'An unknown error occurred'
      console.error(errorMessage)
    }
  }

  return result
}

const baseApi = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithAuth,
  tagTypes: ['brain_report'],
  endpoints: () => ({}),
})

export default baseApi
